import { useEffect, useState } from "react";
import ios from "../Images/qr/2.jpg";
import android from "../Images/qr/1.jpg";

const QRSection = () => {
  const [device, setDevice] = useState("");

  useEffect(() => {
    const ua = navigator.userAgent;

    if (/Android/i.test(ua)) {
      setDevice("android");
    } else if (/iPhone|iPad|iPod/i.test(ua)) {
      setDevice("ios");
    } else {
      setDevice("desktop"); 
    }
  }, []);

  return (
    <div>
      {device === "ios" && (
        <img src={ios} alt="iOS QR" className="w-100" />
      )}

      {device === "android" && (
        <img src={android} alt="Android QR" className="w-100" />
      )}

      {device === "desktop" && (
  <div style={{ display: "flex", gap: "20px", padding: "10px" }}>
    <img src={ios} width="100" />
    <img src={android} width="100" />
  </div>
)}
    </div>
  );
};

export default QRSection;